<div #contentWrapper [ngClass]="expanded ? 'is-expanded' : 'is-cropped'" class="wrapper"
  (click)="!expanded ? expandTextContainer() : null" [class.is-single-row]="visibleLines() == 1"
  [style.height]="!expanded ? calcHeight : null" [style.min-height]="!expanded ? calcMinHeight : null">

  <!-- text - when passed via input-->
  @if (text) {
    <span #content [innerHTML]="text"></span>
  }

  <!-- content projection -->
  @if (!text) {
    <span #content style="display: block">
      <ng-content></ng-content>
    </span>
  }

  <!-- button when set inline -->
  @if (buttonInline() && !expanded) {
    <ng-container *ngTemplateOutlet="button"></ng-container>
  }

  <!-- The gradient that masks the bottom of the element -->
  @if (!expanded) {
    <span class="mask" [ngStyle]="blurColor() && {'background-image': getBgBlur() }"
      [matTooltip]="tooltipText() | translate" matTooltipShowDelay="500">
    </span>
  }
</div>

<!-- button when set not inline -->
@if (!buttonInline() && !expanded) {
  <ng-container *ngTemplateOutlet="button"></ng-container>
}

<!-- button template -->
<ng-template #button>
  <button mat-button color="primary" class="expand-button"
    [class.mat-icon-button]="!buttonLabel"
    [class.is-inline]="buttonInline()"
    [class.is-smaller]="buttonSize() === 'small' && !buttonInline()"
    (click)="expandTextContainer()"
    [matTooltip]="tooltipText() | translate"
    [attr.aria-label]="!buttonLabel ? ('research.aria.expand.text' | translate) : null">
    @if (buttonLabel) {
      <span>{{buttonLabel}}</span>
    }
    @if (!buttonLabel) {
      <mat-icon svgIcon="chevron-down"></mat-icon>
    }
  </button>
</ng-template>
